import * as faker from 'faker/locale/en_US';


/**
 *  `DxFakeDataService` - предоставляет функционал для генерации случайных данных.
 *  По факту это обертка на либой faker.js. Библиотека предоставляет внушительный API
 *  для генерированя случайных данных.
 *
 *  "Зачем создавать обертку?" - спросите вы. Затем что:
 *  1. Источник фэйковых данных модет изменится, а изменения следует отделять и инкапсулировать.
 *  2.
 **/
export class DxFakeDataGenerator {
  private static _initialized: boolean = false;
  public static generator: any;

  /** Аналог блока статической инициализации **/
  public static initialize(): void {
    if(!DxFakeDataGenerator._initialized) {
      faker.seed(new Date().getTime());
      DxFakeDataGenerator.generator = faker;
      DxFakeDataGenerator._initialized = true;
    }
  }

  public static getRandomFullName(): string {
    let name = DxFakeDataGenerator.generator.name.firstName();
    name += ' ';
    name += DxFakeDataGenerator.generator.name.lastName();
    return name;
  }

  public static getRandomAccount(): string {
    return DxFakeDataGenerator.generator.finance.account(6);
  }

  public static getRandomAmount(min: number, max: number): number {
    const amount = DxFakeDataGenerator.generator.finance.amount(min, max);
    return parseFloat(amount);
  }


  public static getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  public static getRandomId(): number {
    return Math.round((new Date().getTime() / 1000) * Math.random());
  }
}
// Тригаем инициализацию статики
DxFakeDataGenerator.initialize();
